import { createAction } from '@reduxjs/toolkit'

export const HISTORY_LOAD_EXPORTS = 'HISTORY_LOAD_EXPORTS'
export const HISTORY_LOAD_AUDIT = 'HISTORY_LOAD_AUDIT'
export const HISTORY_LOAD_VERSIONS = 'HISTORY_LOAD_VERSIONS'
export const HISTORY_LOAD_VERSION_DATA = 'HISTORY_LOAD_VERSION_DATA'
export const HISTORY_GENERATE = 'HISTORY_GENERATE'

export const historyLoadExports = createAction(HISTORY_LOAD_EXPORTS)
export const historyLoadAudit = createAction(HISTORY_LOAD_AUDIT)
export const historyLoadVersions = createAction(HISTORY_LOAD_VERSIONS)
export const historyLoadVersionData = createAction(HISTORY_LOAD_VERSION_DATA)
export const historyGenerate = createAction(HISTORY_GENERATE)
